import '~/scss/pixwel.scss';
import '~/node_modules/video.js/dist/video-js.css';
import '~/node_modules/react-datepicker/dist/react-datepicker.css';
import '~/node_modules/rc-tooltip/assets/bootstrap.css';
import '~/node_modules/react-circular-progressbar/dist/styles.css';
import '~/node_modules/react-toastify/dist/ReactToastify.css';
